export default __webpack_public_path__ + "static/media/Vector2.bc958f6c.svg";